export const getInformation = () => {
    return fetch('/customers/get-additional-tires-price/');
};

export const purchaseQuery = (data, csrf_token) => {
    return fetch('/customers/purchase-additional/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getGeoLocations = () => {
    return fetch('/api/v1/geo-locations/');
};

export const getOnboardingInfoQuery = () => {
    return fetch('/api/v1/customers/onboarding/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const skipOnboardingQuery = (data) => {
    return fetch('/api/v1/customers/onboarding/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
